import apiCall from 'apps/investment/apiCalls/stockOrder';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

export const InvestmentStockOrderListPage = () => (
  <ListPage
    title="All Stock Orders"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={FilterForm}
  />
);

const FilterForm = () => <DynamicFilterForm fields={filterConfig} />;

export const InvestmentStockOrderDetailPage = props => (
  <DetailPage
    title="Stock Order"
    apiCall={apiCall}
    listUrl={`/investment/stock-orders`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);
